/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import DropDownSelect from "../../../../components/DropDownSelect/DropDownSelect";
import { SERVICES } from "../../../../components/Layout/Services/MasterDataServices";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";

const initialFormValue = {
  dateOfBirthFrom: "",
  dateOfBirthTo: "",
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
  appointedAtFrom: "",
  appointedAtTo: "",
  conferralDateFrom: "",
  conferralDateTo: "",
};
const MAINLINE_POSITION = "MAINLINE_POSITION";
const DEPUTY_POSITION = "DEPUTY_POSITION";

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
function AdvancedSearch({
  updatePayableCity,
  updatePaymentMethod,
  updatePaymentGateway,
  updateUinType,
  updateReceiptType,
  onAmountChange,
  advancedSearchValues,
  clearValues,
  setAdvancedSearchValues,
}) {
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [profession, setProfession] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState("");
  const [positions, setPositions] = useState([]);
  const [selectedMainlinePositions, setSelectedMainlinePositions] = useState(
    [],
  );
  const [mainlinePositions, setMainlinePositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [selectedGohonzonTypes, setSelectedGohonzonTypes] = useState([]);
  const gohonzonTypeOptions = [
    { entityTitle: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
    { entityTitle: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
  ];
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const getPositions = async (type) => {
    try {
      let url;
      if (type === MAINLINE_POSITION) {
        url = `${SERVICES.GET_POSITIONS}?type=${MAINLINE_POSITION}`;
      } else if (type === DEPUTY_POSITION) {
        url = `${SERVICES.GET_POSITIONS}?type=${DEPUTY_POSITION}`;
      } else {
        throw new Error("Invalid position type");
      }

      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        if (type === MAINLINE_POSITION) {
          const mainlineFormattedPos = data.data.map((d) => ({
            entityTitle: d.name,
            value: d.positionId,
          }));
          setMainlinePositions(mainlineFormattedPos);
        } else if (type === DEPUTY_POSITION) {
          const othersFormattedPos = data.data.map((d) => ({
            entityTitle: d.name,
            value: d.positionId,
          }));
          setPositions(othersFormattedPos);
          // setPositions(data.data);
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleProfessions = async () => {
    try {
      const url = `${SERVICES.GET_PROFESSIONS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line no 98", data);
        setProfession(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleDateOfBirthChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      dateOfBirthFrom: startDate,
      dateOfBirthTo: endDate,
    }));
  };
  const handleDateOfJoiningChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      dateOfJoiningFrom: startDate,
      dateOfJoiningTo: endDate,
    }));
  };
  const handleDateOfAppointmentChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      appointedAtFrom: startDate,
      appointedAtTo: endDate,
    }));
  };
  const handleDateOfConferallChange = (startDate, endDate) => {
    setInitialAdvanceFormValue((prevValues) => ({
      ...prevValues,
      conferralDateFrom: startDate,
      conferralDateTo: endDate,
    }));
  };
  useEffect(() => {
    getPositions(MAINLINE_POSITION);
    getPositions(DEPUTY_POSITION);
    handleProfessions();
  }, []);
  useEffect(() => {
    // Update the state in the parent component when values change
    setAdvancedSearchValues((prevValues) => ({
      ...prevValues,
      dateOfBirthFrom: initialAdvanceFormValue.dateOfBirthFrom,
      dateOfBirthTo: initialAdvanceFormValue.dateOfBirthTo,
      dateOfJoiningFrom: initialAdvanceFormValue.dateOfJoiningFrom,
      dateOfJoiningTo: initialAdvanceFormValue.dateOfJoiningTo,
      selectedProfession: selectedProfession || "",
      selectedMainlinePositions,
      selectedPositions,
      appointedAtFrom: initialAdvanceFormValue.appointedAtFrom,
      appointedAtTo: initialAdvanceFormValue.appointedAtTo,
      conferralDateFrom: initialAdvanceFormValue.conferralDateFrom,
      conferralDateTo: initialAdvanceFormValue.conferralDateTo,
      selectedGohonzonTypes,
      mainlinePositions,
      positions,
      gohonzonTypeOptions,
    }));
  }, [
    initialAdvanceFormValue,
    selectedProfession,
    selectedMainlinePositions,
    selectedPositions,
    selectedGohonzonTypes,
  ]);
  useEffect(() => {
    if (clearValues) {
      setInitialAdvanceFormValue(initialFormValue);
      setSelectedMainlinePositions([]);
      setSelectedPositions([]);
      setSelectedGohonzonTypes([]);
    }
  }, [clearValues]);
  useEffect(() => {
    if (queryParams.get("dateOfBirthFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        dateOfBirthFrom: "",
        dateOfBirthTo: "",
      }));
    }
    if (queryParams.get("dateOfJoiningFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        dateOfJoiningFrom: "",
        dateOfJoiningTo: "",
      }));
    }
    if (queryParams.get("appointedAtFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        appointedAtFrom: "",
        appointedAtTo: "",
      }));
    }
    if (queryParams.get("conferralDateFrom") === null) {
      setInitialAdvanceFormValue((prevValues) => ({
        ...prevValues,
        conferralDateFrom: "",
        conferralDateTo: "",
      }));
    }
    if (queryParams.get("mainlinePositionIds") === null) {
      setSelectedMainlinePositions([]);
    }
    if (queryParams.get("dualPositionIds") === null) {
      setSelectedPositions([]);
    }
    if (queryParams.get("gohonzonTypes") === null) {
      setSelectedGohonzonTypes([]);
    }
  }, [
    queryParams.get("dateOfBirthFrom"),
    queryParams.get("dateOfJoiningFrom"),
    queryParams.get("mainlinePositionIds"),
    queryParams.get("appointedAtFrom"),
    queryParams.get("conferralDateFrom"),
    queryParams.get("dualPositionIds"),
    queryParams.get("gohonzonTypes"),
  ]);
  // console.log("line 158", mainlinePositions);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={4} columnSpacing={5}>
        <Grid item xs={6}>
          <DateRangePicker
            label="Date of Birth"
            name="dateOfBirth"
            startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
            endDateVal={initialAdvanceFormValue.dateOfBirthTo}
            onChange={handleDateOfBirthChange}
          />
        </Grid>
        <Grid item xs={6}>
          <DateRangePicker
            label="Date of Joining"
            name="dateOfJoining"
            startDateVal={initialAdvanceFormValue.dateOfJoiningFrom}
            endDateVal={initialAdvanceFormValue.dateOfJoiningTo}
            onChange={handleDateOfJoiningChange}
            customLeft={-88}
          />
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.profession}
            options={getOptions(profession, "professionsId")}
            label="Profession"
            name="professionsId"
            value={selectedProfession}
            onChange={(selectedValue) => {
              setSelectedProfession(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
            // disabled
          />
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <DropDownSelect
            title="Mainline Leadership Position"
            name="mainlinePositionIds"
            multiple
            selectOptions={mainlinePositions}
            value={selectedMainlinePositions}
            setValue={setSelectedMainlinePositions}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownSelect
            title="Other Positions"
            name="dualPositionIds"
            multiple
            selectOptions={positions}
            value={selectedPositions}
            setValue={setSelectedPositions}
            style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
        <Grid item xs={6}>
          {/* <FormControlLabel control={<Checkbox />} label="Cancelled Cheque" /> */}
          <DateRangePicker
            label="Appointment Date"
            name="appointedAt"
            // disabled
            startDateVal={initialAdvanceFormValue.appointedAtFrom}
            endDateVal={initialAdvanceFormValue.appointedAtTo}
            onChange={handleDateOfAppointmentChange}
            customTop={-235}
          />
        </Grid>
        <Grid item sx={6}>
          <DateRangePicker
            label="Conferral Date"
            name="conferralDate"
            startDateVal={initialAdvanceFormValue.conferralDateFrom}
            endDateVal={initialAdvanceFormValue.conferralDateTo}
            onChange={handleDateOfConferallChange}
            customTop={-235}
            customLeft={-88}
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownSelect
            title="Gohonzon Type"
            name="gohonzonTypes"
            multiple
            selectOptions={gohonzonTypeOptions}
            value={selectedGohonzonTypes}
            setValue={setSelectedGohonzonTypes}
            // style={{ maxWidth: 290 }}
            className="dropdown-multiple"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
export default AdvancedSearch;
